export default __webpack_public_path__ + "locales/pt/DeleteThirdPartyDialog.json?hash=f5239e519abe7ec60b76cfcd0c5e45fd";